import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-secure-mask',
    templateUrl: './secure-mask.component.html',
    styleUrls: ['./secure-mask.component.scss'],
    standalone: false
})
export class SecureMaskComponent implements OnInit, OnChanges {
  @Input() value = '';
  valueWithMask = '';
  showCount = 4;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.value) {
      return;
    }
    let splittedValue = this.value.split('/');
    splittedValue = splittedValue.map(v => v.toString()
        .split('')
        .map((char, i) => i < (v.length - this.showCount) ? '*' : char)
        .join(''));
    this.valueWithMask = splittedValue
      .join('<br>');

  }

}
